<template>
    <content-dashboard :hide="true">
        <v-card>
            <v-card-title class="subtitle-1">Filtros</v-card-title>
            <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                    <v-col cols="12" xs="12" md="4" sm="4">
                        <v-text-field
                            dense
                            type="date"
                            label="Data Infração (Início)"
                            v-model="filtro.data_inicial"
                            outlined
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" xs="12" md="4" sm="4">
                        <v-text-field
                            dense
                            type="date"
                            label="Data Infração (Fim)"
                            v-model="filtro.data_final"
                            outlined
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" sm="4">
                        <v-select
                            :items="optionsStatus"
                            outlined
                            dense
                            v-model="filtro.id_status"
                            label="Status"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-form>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="primary" @click="load(1, filtro)">Pesquisar</v-btn>
                <v-btn color="primary" outlined class="ml-5" @click="reset">Limpar</v-btn>
                <v-btn color="primary" class="ml-5" @click="downloadXLSX(filtro)">Exportar Dados</v-btn>
            </v-card-actions>
        </v-card>

        <v-divider class="my-2 mb-10 mt-10"></v-divider>

        <v-card>
            <v-card-title class="subtitle-1">Resultado</v-card-title>
            <v-card-text>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Número Auto</th>
                                <th class="text-left">Data de Infração</th>
                                <th class="text-left">Enquadramento</th>
                                <th class="text-left">Status</th>
                                <th class="text-left">Data Envio NP</th>
                                <th class="text-left">Data Vencimento NP</th>
                                <th class="text-left">Valor NP</th>
                                <th class="text-left">Valor Pago</th>
                                <th class="text-left">Data do Pagamento</th>
                                <th class="text-left">Origem</th>
                                <th class="text-left">Unidade Autuadora</th>
                                <th class="text-left">Documentos</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, key) in items" :key="key">
                                <td>{{ item.numero_auto }}</td>
                                <td>{{ item.data_infracao | data }}</td>
                                <td>{{ item.enquadramento }}</td>
                                <td>{{ item.status_name.name }}</td>
                                <td>{{ item.envio_notificacao_penalidade | data }}</td>
                                <td>{{ item.vencimento_notificacao_penalidade | data }}</td>
                                <td>R$ {{ item.valor_np }}</td>
                                <td>R$ {{ item.valor_pagamento }}</td>
                                <td>{{ item.data_pagamento | data }}</td>
                                <td>{{ item.origem_auto }}</td>
                                <td>{{ item.unidade_autuadora }}</td>
                                <td>
                                    <v-btn
                                        color="primary"
                                        class="mr-2"
                                        outlined
                                        @click="downloadNotificacao('np', item.id_auto)"
                                    >
                                        <v-icon left>mdi-file</v-icon>NP
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-pagination
                    color="primary"
                    v-model="currentData.current_page"
                    :length="currentData.last_page"
                    :total-visible="10"
                    @input="load($event, filtro)"
                ></v-pagination>
            </v-card-actions>
        </v-card>
    </content-dashboard>
</template>

<script>
import urlApi from "@/routes/urlApi";
import { showError } from "@/global";
import queryString from "querystring";
import downloadXLSXBlob from "../../utils/downloadXLSXBlob";

export default {
    name: "ProcessoDefesa",
    data() {
        return {
            loading: false,
            valid: true,
            rules: [v => !!v || "Este campo é Obrigatório"],
            filtro: {},
            items: [],
            currentData: [],
            optionsStatus: [
                { value: 1, text: "Auto Válido" },
                { value: 2, text: "Auto Cancelado" },
                { value: 3, text: "Auto Insubsistente" },
                { value: 4, text: "Auto Sub Judice" },
                { value: 5, text: "Auto em Defesa Prévia" },
                { value: 6, text: "Auto em Defesa Jari" },
                { value: 7, text: "Auto Prescrito" },
                { value: 8, text: "Auto Pago" },
            ],
        };
    },

    created() {
        //this.load();
    },

    methods: {
        load(page = 1 ,filtro) {
            this.$store.commit("overlay/toggle", true);
            
            const filter = queryString.stringify(filtro);

            const url = `${urlApi}/relatorio/autos-analitico-financeiro-np?page=${page}&${filter}`;

            this.$http.get(url).then(res => {
                const response   = res.data.data;

                this.items       = response.data;
                this.currentData = response;

                this.$store.commit("overlay/toggle", false);
            }).catch((error) => {
                let erro = error.body.data;
        
                showError(`Ops, ${erro}`);

                this.$store.commit("overlay/toggle", false);
            });
        },

        downloadNotificacao(tipoNotificacao, idAuto) {
            this.$store.commit("overlay/toggle", true);

            const url = `${urlApi}/auto/visualizar/${tipoNotificacao}/${idAuto}`;

            this.$http.get(url).then(response => {
                const { base64, numero_auto } = response.body;

                let a      = document.createElement("a");
                a.href     = `data:application/octet-stream;base64,${base64}`;
                a.download = `${tipoNotificacao}-${numero_auto}.pdf`;
                a.click();

                this.$store.commit("overlay/toggle", false);
            }).catch((error) => {
                let erro = error.body.data;

                showError(`Ops,\n${erro}`);

                this.$store.commit("overlay/toggle", false);
            });
        },
        
        downloadXLSX(filtro, exportar = true) {
            this.$store.commit("overlay/toggle", true);
            
            const filter = queryString.stringify(filtro);

            const url = `${urlApi}/relatorio/autos-analitico-financeiro-np?exportar=${exportar}&${filter}`;

            this.$http.get(url, { responseType: 'blob' }).then(response => {
                downloadXLSXBlob(response, 'analitico-financeiro.xlsx');

                this.$store.commit("overlay/toggle", false);
            }).catch((error) => {
                let erro = error.body.data;
        
                showError(`Ops, ${erro}`);

                this.$store.commit("overlay/toggle", false);
            });
        },

        reset() {
            this.filtro = {};
        },
    }
};
</script>